<template>
  <div id="square">
    <section class="header point" @click="publish()">
      <img :src="imgurl" alt="">
    </section>
    <ux-spin size="large" :spinning="spinning">
      <section v-if="list.length > 0" class="filter mt-13">
        <filter-custom @filterChange="filterChange" />
      </section>
    
      <section class="square-list mt-10">
        <div v-for="item in list" :key="item.id" class="square-list-card" @click.stop="sign(item)">
          <div class="square-list-card-prop">
            <img :src="item.prop" alt="">
          </div>
          <div class="square-list-card-header text-over">
            <span class="square-list-card-name">{{ item.name }}</span>
          </div>
          <div class="square-list-card-desc mt-8 text-over">
            {{ item.desc }}
          </div>
          <div class="square-list-card-type mt-10">
            <div>类型： {{ item.type }}</div>
            <div>报名截止： {{ item.time }}</div>
          </div>
          <div class="square-list-card-fotter">
            <div>
              <ux-popover trigger="hover" :content="item.money">
                <div class="square-list-card-money text-over">
                  {{ item.money }}
                </div>
              </ux-popover>
              <div class="square-list-card-count">
                已有<span style="color: #4285F4">{{ item.count }}</span>人报名成功
              </div>
            </div>
            <ux-button v-if="!item.over && item.traceStatus === '10'" @click.stop="sign(item)">
              报名
            </ux-button>
            <ux-button v-else disabled @click.stop="sign(item)">
              已结束
            </ux-button>
          </div>
        </div>
      </section>
    
      <section v-if="list.length === 0">
        <empty />
      </section>
      <section v-if="list.length > 0" class="mt-20 clearfix">
        <ux-pagination
          class="float-right"
          :current="pagination.current"
          :total="pagination.total"
          :page-size-options="[8, 12, 16]"
          show-size-changer
          show-quick-jumper
          @page-size-change="pageSizeChange"
          @change="change"
        />
      </section>
    </ux-spin>
  </div>
</template>
<script>
import moment from 'moment'
import {squareService} from '../service';
import filterCustom from './component/filter.vue';
import empty from '../components/empty.vue'
const imgurl = require('../assets/banner.png');

export default {
  components: {
    filterCustom,
    empty
  },
  data() {
    return {
      list: [],
      curent: 1,
      pagination: {
        current: 1,
        pageSize: 8,
        total: 0
      },
      filterParmas: {
        categoryThirCode: 'R9019522',
        customizedType: '',
        customizedTypeArry: [],
        sortField: '',
        sortType: '',
        // page: 1,
        // pageSize: 8
      },
      imgurl: imgurl,
      spinning: true
    }
  },
  created() {
    this.getList();
  },
  methods: {
    sign(item) {
      this.$router.push({name: 'sign', query: {customizedCode: item.customizedCode}})
    },
    publish() {
      this.$router.push({name: 'publish'})
    },
    pageSizeChange(current, size) {
      this.pagination.current = 1;
      this.pagination.pageSize = size;
      this.getList();
    },
    change(current, size) {
      this.pagination.current = current;
      this.getList();
    },
    getList() {
      const {customizedTypeArry, ...params} = this.filterParmas;
      Object.assign(params, {
        page: this.pagination.current,
        pageSize: this.pagination.pageSize
      })
      this.spinning = true;
      squareService.getList(params).then((res) => {
        this.spinning = false;
        this.list = [];
        this.pagination.total = 0;
        if(res.datas.length > 0) {
          this.list = this.fomatData(res.datas);
          this.pagination.total = res.totalDataCount;
        }
      }, (errMsg) => {
        this.spinning = false;
      })
    },
    fomatData(data) {
      const list = [];
      data.forEach((item) => {
        item.minBudget = item.minBudget ? item.minBudget : 0;
        item.maxBudget = item.maxBudget ? item.maxBudget : 0;
        const temp = {
          name: item.serverName,
          desc: item.description,
          type: '营销制定',
          prop: this.requireType(item.customizedType),
          time: item.deadlineDate,
          count: item.alreadyApplyNumber,
          money: `¥${item.minBudget}-¥${item.maxBudget}`,
          customizedCode: item.customizedCode,
          over: this.calcTasKStatus(item.deadlineDate),
          traceStatus: item.traceStatus
        }
        list.push(temp);
      })
      return list;
    },
    calcTasKStatus(deadlineDate) {
      const endTime = `${deadlineDate} 23:59:59`
      const now = new Date().getTime();
      const end = new Date(endTime).getTime();
      return end - now < 0
    },
    requireType(type) {
      let url = ''
      if(type === '1' || type === '3') {
        url = require('../assets/target.png')
      } else {
        url = require('../assets/public.png')
      }
      return url;
    },
    filterChange(data) {
      this.setParams(data)();
      this.pagination.current = 1;
      this.getList()
    },
    setParams(data) {
      const temp = {
        BiddingFilter: () => {
          if(data.checked) {
            this.filterParmas.customizedTypeArry.push(data.option.value)
          } else {
            const index = this.filterParmas.customizedTypeArry.indexOf(data.option.value);
            this.filterParmas.customizedTypeArry.splice(index, 1);
          }
          this.filterParmas.customizedType = this.filterParmas.customizedTypeArry.length === 1 ? this.filterParmas.customizedTypeArry[0] : ''
        },
        sortFilter: () => {
          if(data.checked) {
            this.filterParmas.sortField = data.option.value;
            this.filterParmas.sortType = data.sort ? 'desc' : "asc";
          }
        }
      }
      return temp[data.option.orderTo]
    }
  }
}
</script>
<style scoped>
#square {
  width: 1190px;
  min-width: 1190px;
  margin: auto;
  padding-top: 7px;
}
.square-list {
  display: flex;
  flex-wrap: wrap;
  width: 1190px;
  min-width: 1190px;
}
.square-list-card {
  position: relative;
  width: 290px;
  padding: 20px 20px 18px;
  min-height: 186px;
  border-radius: 5px;
  background: #fff;
  margin-right: 10px;
  margin-bottom: 10px;
  cursor: pointer;
}
.square-list-card:nth-child(4n) {
  margin-right: 0px !important;
}
.square-list-card-header {
  width: 160px;
}
.square-list-card-name {
  font-size: 16px;
  color: #333333;
}
.square-list-card-desc {
  font-size: 12px;
  color: #999999;
  line-height: 20px;
  min-height: 30px;
}
.square-list-card-type {
  display: flex;
  justify-content: space-between;
  font-size: 12px;
  color: #333333;
}
.square-list-card-fotter {
  display: flex;
  justify-content: space-between;
  margin-top: 16px;
}
.square-list-card-count {
  font-size: 12px;
  color: #CCCCCC;
  line-height: 12px;
  margin-top: 5px;
}
.square-list-card-money {
  font-size: 14px;
  color: #E02020;
  line-height: 16px;
  font-weight: 700;
  width: 138px;
}
.square-list-card-prop {
  position: absolute;
  right: 20px;
  top: 0;
  color: #fff;
  /* background: blue; */
}
#square >>> .ux-btn {
    line-height: 1;
    display: inline-block;
    font-weight: 400;
    text-align: center;
    touch-action: manipulation;
    cursor: pointer;
    background-image: none;
    border: 1px solid transparent;
    white-space: nowrap;
    padding: 0 34px;
    font-size: 12px;
    border-radius: 2px;
    height: 30px;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
    transition: all 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);
    position: relative;
    color: #4285F4 ;
    background-color: #fff;
    border-color: #4285F4 ;
}
#square >>> .ux-btn:hover, .ux-btn:focus {
    color: #fff;
    background-color:#4285F4;
    border-color: #4285F4;
}
#square >>> .ux-pagination-item-active {
    border-color: #FF6600;
    background: #FF6600;
    font-weight: 500;
    color: #fff !important;
    border-radius: 2px;
}
#square >>> .ux-pagination-item-active a {
    color: #fff;
} 
.ux-pagination-item-active:focus a, .ux-pagination-item-active:hover a {
    color: #fff;
}
#square >>> .ux-btn[disabled] {
  color: #aaa;
  background-color: #f5f5f5;
  border-color: #d9d9d9;
  cursor: not-allowed;
}
#square >>> .ux-pagination-options-quick-jumper button {
    display: inline-block;
    font-weight: 400;
    text-align: center;
    touch-action: manipulation;
    cursor: pointer;
    background-image: none;
    border: 1px solid transparent;
    white-space: nowrap;
    padding: 0 15px;
    font-size: 12px;
    border-radius: 2px;
    height: 32px;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
    transition: all 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);
    position: relative;
    color: #666666;
    background-color: #e9e9e9;
    border-color: #D7D7DA;
    height: 28px;
    line-height: 27px;
    margin-left: 8px;
}
</style>